export default "__VITE_ASSET__c93310d3__"